
export { default as TranslationCard } from './TranslationCard';